module.exports = __webpack_public_path__ + "media/images/about/end-8e7364e156122ba24a144d6bbf194517.png";